__turbopack_context__.v({
  "galleryImageInset": "ImageContainer-module-scss-module__46yDKa__galleryImageInset",
  "image": "ImageContainer-module-scss-module__46yDKa__image",
  "imageActivator": "ImageContainer-module-scss-module__46yDKa__imageActivator",
  "imageContain": "ImageContainer-module-scss-module__46yDKa__imageContain",
  "imageTag": "ImageContainer-module-scss-module__46yDKa__imageTag",
  "imageWrapper": "ImageContainer-module-scss-module__46yDKa__imageWrapper",
  "placeholderText": "ImageContainer-module-scss-module__46yDKa__placeholderText",
});
